import React from "react";

export const FilterIconV2 = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66675 14.1663H11.3334M2.16675 5.83301L18.8334 5.83301L2.16675 5.83301ZM5.50008 9.99967L15.5001 9.99967L5.50008 9.99967Z"
        stroke="#15112D"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
